import React from 'react';
const modules = [{
  emoji: '💃',
  title: 'FONDATIONS DE LA DANSE™',
  description: 'Retrouvez les fondamentaux essentiels pour structurer vos cours : principes pédagogiques, échauffements, posture, coordination, musicalité, préparation physique et bases techniques.'
}, {
  emoji: '🩰',
  title: 'BIBLIOTHÈQUE DE MOUVEMENTS™',
  description: "Accédez à une bibliothèque organisée d'exercices, mouvements, combinaisons et progressions avec différentes variantes selon le niveau de vos élèves."
}, {
  emoji: '📋',
  title: 'SYSTÈME DE PLANIFICATION DES COURS™',
  description: "Ne partez plus d'une page blanche. Utilisez des structures, modèles et outils déjà organisés pour préparer rapidement des séances cohérentes, progressives et professionnelles."
}, {
  emoji: '⚡',
  title: "COURS PRÊTS À L'EMPLOI™",
  description: 'Ouvrez, choisissez et enseignez. Retrouvez des cours complets déjà structurés avec objectifs, exercices, progressions et déroulement de séance, prêts à utiliser ou à adapter.'
}, {
  emoji: '📅',
  title: 'PROGRAMMES PROGRESSIFS™',
  description: 'Organisez votre enseignement sur plusieurs semaines ou plusieurs mois grâce à des progressions pédagogiques, objectifs, calendriers et outils de suivi déjà structurés.'
}, {
  emoji: '🗂️',
  title: 'OUTILS PROFESSIONNELS DU PROFESSEUR™',
  description: "Évaluations, fiches de suivi, check-lists, documents pédagogiques, outils d'organisation et ressources imprimables pour simplifier votre travail au quotidien."
}];
export function TomiSection() {
  return <section className="py-8 px-4 sm:px-6 bg-white border-y-4 border-brand-cream" data-id="element-178" data-mp="wvpf2i2oz7t2">
      <div className="text-center mb-6" data-id="element-179" data-mp="11wv8yj839146">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-title mb-2 uppercase leading-tight" data-id="element-180" data-mp="11tr19bvezn8r">
          LA SOLUTION QUE VOUS ATTENDIEZ
        </h2>
        <p className="text-base font-subheading font-bold text-brand-rose mb-3 uppercase tracking-wide" data-id="element-181" data-mp="2d9pfdu5g8zgu">
          UN SYSTÈME COMPLET DE PLANIFICATION 6-EN-1
        </p>
        <div className="inline-block bg-brand-rose text-white px-4 py-1.5 rounded-md mb-4 shadow-sm" data-id="element-182" data-mp="88v0htsbhp34">
          <p className="font-button font-bold text-sm tracking-wide" data-id="element-183" data-mp="m8o1chxk5lot">
            💃 DANCE PRO™ — Le Système Complet
          </p>
        </div>
        <p className="text-sm sm:text-base text-brand-text font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-184" data-mp="i5zswbcragsd">
          DANCE PRO™ rassemble en un seul endroit tout ce que vous passez
          habituellement des heures à préparer : cours complets, exercices,
          progressions pédagogiques, planification, évaluations et outils
          professionnels. Ouvrez le système, choisissez ce dont vous avez besoin
          et adaptez-le simplement à vos élèves.
        </p>
      </div>

      <div className="flex flex-col gap-3" data-id="element-185" data-mp="36y3nv0pquo8n">
        {modules.map((module, i) => <div key={i} className="bg-brand-ivory border border-brand-cream p-4 rounded-lg flex gap-3 items-start shadow-sm hover:shadow-md transition-shadow" data-id="element-186" data-mp="32xthhmy1hvt9" data-mpi={i}>
            <div className="text-2xl shrink-0 leading-none mt-0.5" data-id="element-187" data-mp="2xlwf7qj8z9u9">
              {module.emoji}
            </div>
            <div data-id="element-188" data-mp="2iy1mia58p5h6">
              <h3 className="text-base font-bold text-brand-title leading-tight mb-1" data-id="element-189" data-mp="2iudpv24i02y8">
                {module.title}
              </h3>
              <p className="text-brand-text text-sm font-medium leading-relaxed" data-id="element-190" data-mp="3bkmcb662h9im">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}